import { getRequest } from "@/api/helpers"
import { isEmpty } from "@/utils/common-helpers"
import { clsx } from "clsx"
import { AsyncPaginate } from "react-select-async-paginate"

const CustomAsyncPaginate = ({
  api,
  selectedData,
  setSelectedData,
  labelName,
  valueName,
  customLabel,
  customWidth,
  needToAddMarginLeft,
  handleChange,
  reset,
  noBorder,
}: any) => {
  const fetchData = async () => {
    let options: any = []

    const response = await getRequest(api)

    if (isEmpty(response) || !response.status) {
      return {
        options: options,
        hasMore: false,
      }
    }
    options.push({
      label: customLabel,
      value: "",
    })

    if (response.data.length > 0) {
      response.data.map((option: any) => {
        options.push({
          label: option[labelName],
          value: option[valueName],
        })
      })
    }

    return {
      options: options,
      hasMore: false,
    }
  }
  return (
    <>
      <AsyncPaginate
        key={reset}
        loadOptions={fetchData}
        id="product_categories"
        isSearchable={false}
        className={clsx(
          "react-select-container",
          !isEmpty(customWidth) ? customWidth : "w-auto",
          !isEmpty(needToAddMarginLeft) && needToAddMarginLeft ? "lg:mr-3" : "",
          noBorder ? "no-border" : "",
        )}
        classNamePrefix="react-select"
        placeholder={customLabel}
        onChange={(e: any) => {
          if (!isEmpty(handleChange)) {
            handleChange()
          }
          setSelectedData(e)
        }}
        value={selectedData}
      />
    </>
  )
}

export default CustomAsyncPaginate
